// extracted by mini-css-extract-plugin
export default {"titleContainer":"Title_titleContainer__Z5uxz"};